var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10058_2105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1423 41.9969L37.0448 32.8963C43.852 23.8003 41.9959 10.9086 32.8991 4.10196C23.8023 -2.70466 10.9095 -0.848719 4.10231 8.24731C-2.70489 17.3433 -0.84879 30.235 8.248 37.0417C15.5553 42.5093 25.5917 42.5093 32.8991 37.0417L42.0004 46.1423C43.1442 47.2859 44.9985 47.2859 46.1422 46.1423C47.2859 44.9986 47.2859 43.1444 46.1422 42.0009L46.1423 41.9969ZM20.6494 35.2852C12.5646 35.2852 6.01065 28.7318 6.01065 20.6477C6.01065 12.5635 12.5646 6.01014 20.6494 6.01014C28.7342 6.01014 35.2881 12.5635 35.2881 20.6477C35.2795 28.7281 28.7306 35.2766 20.6494 35.2852Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10058_2105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search-2.86e9a4a566e07b552e6db05a71f621e3.svg";
export { ForwardRef as ReactComponent };